import { render, staticRenderFns } from "./Forgot-Security-Question.vue?vue&type=template&id=7936811a&"
import script from "./Forgot-Security-Question.vue?vue&type=script&lang=js&"
export * from "./Forgot-Security-Question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports